import { useReducer, useCallback } from 'react';
import { TDepositState, IUseDepositForm, IUseDepositState } from './IDepositForm';
import { IUseFormPayload } from '../WithdrawForm/IWithdrawForm';
import { bankFormValidation } from '@funds/features/helpers/validation';

export const useDepositForm = (step: TDepositState['step']): IUseDepositForm => {
  const initialValue: IUseDepositState = {
    values: {
      buttonStepHidden: {
        crypto: true,
        usdSwift: true,
      },
      selectedCoin: undefined,
      wallets: undefined,
    },
    errors: {},
  };

  const [state, dispatch] = useReducer(useCallback((state, action) => {

    const getUpdatedData = (
      payload: IUseFormPayload,
      relatedData: IUseFormPayload[]
    ) => {
      const newValues = {
        ...state.values,
        [payload.name]: payload.value,
        ...relatedData.reduce((acc, curr, i) => ({ ...acc, [curr.name]: curr.value }), {}),
      };
      const bicSwiftAsyncError = state.errors.bic_swift_async;
      const errors = bankFormValidation(newValues, payload.name === 'bic_swift');
      if (bicSwiftAsyncError && payload.name !== 'bic_swift') {
        errors.bic_swift_async = bicSwiftAsyncError;
      }

      return {
        errors,
        values: newValues,
      };
    };

    switch (action.type) {
      case 'edit':
        const data = getUpdatedData(action.payload, action.relatedData || []);
        return {
          values: data.values,
          errors: data.errors,
        };

      case 'editMode':
        return {
          ...state,
          values: action.values,
          errors: action.errors,
        };

      case 'setErrors':
        return { ...state, errors: action.errors };

      case 'cleanSwiftExternalError':
        const { bic_swift_external, ...rest } = state.errors;
        return { ...state, errors: { ...rest } };

      default:
        return state;
    }
  }, [step]), initialValue);

  return {
    dispatch,
    values: state.values,
    errors: state.errors,
  };
};
